import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import AdminPage from './pages/AdminPage';
import AutomationPage from './pages/AutomationPage';
import ChecksPage from './pages/ChecksPage';
import DashboardPage from './pages/DashboardPage';
import HomeValueNoDataPage from './pages/HomeValueNoDataPage';
import HomeValueProcessedPage from './pages/HomeValueProcessedPage';
import HomeValueQueuePage from './pages/HomeValueQueuePage';
import HomeValueReviewPage from './pages/HomeValueReviewPage';
import LoginPage from './pages/LoginPage';
import NewItemsProcessedPage from './pages/NewItemsProcessedPage';
import NewItemsQueuePage from './pages/NewItemsQueuePage';
import NewItemsReviewPage from './pages/NewItemsReviewPage';
import PriceChecksProcessedPage from './pages/PriceChecksProcessedPage';
import PriceChecksQueuePage from './pages/PriceChecksQueuePage';
import ProductDetailPage from './pages/ProductDetailPage';
import ProductsPage from './pages/ProductsPage';
import QueuePage from './pages/QueuePage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import UsersPage from './pages/UsersPage';
import VendorsPage from './pages/VendorsPage';

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/unauthorized" element={<UnauthorizedPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />

                    {/* Price Checks */}
                    <Route path="/price-checks" element={<Navigate to="/price-checks/review" replace />} />
                    <Route path="/price-checks/review" element={<ChecksPage />} />
                    <Route path="/price-checks/queue" element={<PriceChecksQueuePage />} />
                    <Route path="/price-checks/processed" element={<PriceChecksProcessedPage />} />

                    {/* Home Value (availability → NetSuite, BOT-411) */}
                    <Route path="/home-value" element={<Navigate to="/home-value/review" replace />} />
                    <Route path="/home-value/review" element={<HomeValueReviewPage />} />
                    <Route path="/home-value/queue" element={<HomeValueQueuePage />} />
                    <Route path="/home-value/processed" element={<HomeValueProcessedPage />} />
                    <Route path="/home-value/no-data" element={<HomeValueNoDataPage />} />

                    {/* New Items */}
                    <Route path="/new-items" element={<Navigate to="/new-items/review" replace />} />
                    <Route path="/new-items/review" element={<NewItemsReviewPage />} />
                    <Route path="/new-items/queue" element={<NewItemsQueuePage />} />
                    <Route path="/new-items/processed" element={<NewItemsProcessedPage />} />

                    {/* All Items */}
                    <Route path="/all-items" element={<ProductsPage />} />
                    <Route path="/all-items/:id" element={<ProductDetailPage />} />

                    {/* Admin (admin role only) */}
                    <Route path="/admin" element={<ProtectedRoute requiredRole="admin"><AdminPage /></ProtectedRoute>} />
                    <Route path="/admin/automation" element={<ProtectedRoute requiredRole="admin"><AutomationPage /></ProtectedRoute>} />
                    <Route path="/admin/jobs" element={<ProtectedRoute requiredRole="admin"><QueuePage /></ProtectedRoute>} />
                    <Route path="/admin/vendors" element={<ProtectedRoute requiredRole="admin"><VendorsPage /></ProtectedRoute>} />
                    <Route path="/admin/users" element={<ProtectedRoute requiredRole="admin"><UsersPage /></ProtectedRoute>} />

                    {/* Legacy redirects */}
                    <Route path="/checks" element={<Navigate to="/price-checks/review" replace />} />
                    <Route path="/products" element={<Navigate to="/all-items" replace />} />
                    <Route path="/products/:id" element={<Navigate to="/all-items" replace />} />
                    <Route path="/queue" element={<Navigate to="/admin/jobs" replace />} />
                    <Route path="/vendors" element={<Navigate to="/admin/vendors" replace />} />

                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
